module.exports = __webpack_public_path__ + "static/media/hiper.ace916a4.svg";